export const palette = {
  blue: '#3C91E6',
  green: '#9FD356',
  dark: '#342E37',
  light: '#FAFFFD',
  orange: '#FA824C',
} as const;

export const chartColors = {
  primary: '#3C91E6',
  secondary: '#9FD356',
  border: '#d4d0d6',
  text: '#6b6570',
} as const;

export const characterColors = {
  blue: palette.blue,
  dark: palette.dark,
  orange: palette.orange,
  green: palette.green,
  lavender: '#c4b8ce',
} as const;
